module.exports = __webpack_public_path__ + "img/Comp-1.gif";